<template>
  <v-sheet :height="''" :class="'cust-page-calendar cust-calendar elevation-1'">
    <v-toolbar
        flat
        dense
        class="cust-calendar-toolbar"
        height="39"
    >
        <v-btn
            fab
            text
            x-small
            color="grey darken-2"
            @click="prev"
        >
            <v-icon small>
                mdi-chevron-left
            </v-icon>
        </v-btn>
        <v-btn
            fab
            text
            x-small
            color="grey darken-2"
            @click="next"
        >
            <v-icon small>
                mdi-chevron-right
            </v-icon>
        </v-btn>

        <v-toolbar-title v-if="this.$refs?.calendar?.lastStart?.date">
            {{ $moment(this.$refs.calendar.lastStart.date).format('DD.MM.YYYY') }} 
            <template v-if="getCalendarPeriod !== 'day' && this.$refs?.calendar?.lastEnd?.date">- {{ $moment(this.$refs.calendar.lastEnd.date).format('DD.MM.YYYY') }}</template>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <div class="status-panel">
            <v-chip-group
                :value="getCalendarPeriod"
                active-class="active-panel-item"
                mandatory
                column
            >

                <v-chip
                    value="day"
                    class="ma-1"
                    small
                    label
                    @click="onPeriodChange('day')"
                >
                    <v-icon class="mr-1"> fas fa-calendar-day </v-icon>
                    {{ $t('День') }}
                    <!--<span v-if="moreOrEqualZero(item.count)"> {{item.count}} </span>-->
                </v-chip>
                <v-chip
                    value="week"
                    class="ma-1"
                    small
                    label
                    @click="onPeriodChange('week')"
                >
                <v-icon class="mr-1"> fas fa-calendar-week </v-icon>
                    {{ $t('Неделя') }}
                    <!--<span v-if="moreOrEqualZero(item.count)"> {{item.count}} </span>-->
                </v-chip>
                <v-chip
                    value="month"
                    class="ma-1"
                    small
                    label
                    @click="onPeriodChange('month')"
                >
                <v-icon class="mr-1"> fas fa-calendar-alt </v-icon>
                    {{ $t('Месяц') }}
                    <!--<span v-if="moreOrEqualZero(item.count)"> {{item.count}} </span>-->
                </v-chip>
            </v-chip-group>
        </div>
    </v-toolbar>
	<v-progress-linear v-if="isPending" height="2" color="#E43958" indeterminate></v-progress-linear>
    <v-calendar
        v-model="focus"
        ref="calendar"
        :events="events"
        
        :type="getCalendarPeriod"
        :weekdays="getPeriod"
        :weekday-format="myDayFormat"
        :event-margin-bottom="0"
        @click:event="showEvent"
        @change="onCalendarChange"
        first-time="07:00"
        :interval-count="15"
        :short-intervals="false"
    >
        <template v-slot:day-body="{ date }">
        <div
            :class="getDayClass(date)"
            class="v-calendar-paint-day"
        >
        </div>
        </template>

        <template v-slot:day="{ date }">
            <div
                :class="getDayClass(date)"
                class="v-calendar-paint-day"
            >
            </div>
        </template>
        
        <template v-slot:day-label="{ date }">
            <span :class="$moment().format('D') == $moment(date).format('D') ? 'day-number today-number' : 'day-number'">{{ $moment(date).format('D') }}</span>
        </template>

        <template v-slot:event="{ event, eventParsed }">
            <div class="calendar-event-content" v-tooltip.top-center="event.name">
                {{ eventParsed.start.time }} - {{ eventParsed.end.time }}
                <template v-if="event.status == '2' && event.recipient">
                    <div>{{ event.recipient }}</div>
                </template>
                <div
                    v-if="event.status == '0'"
                    class="calendar-event-actions"
                >
                    <v-btn
                        icon
                        x-small
                        @click.stop="eventDelete(event)"
                    >
                        <v-icon>fas fa-times</v-icon>
                    </v-btn>
                </div>
            </div>
        </template>
    </v-calendar>

    <v-menu
        v-model="selectedOpen"
        :close-on-content-click="false"
        :activator="selectedElement"
        offset-x
        min-width="400px"
        max-width="400px"
    >
        <v-card
            color="grey lighten-4"
            flat
            min-width="400px"
            max-width="400px"
        >
            <v-toolbar
                :color="selectedEvent.color"
                dark
                dense
                flat
            >
                <v-toolbar-title>{{ selectedEvent.name }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text class="wrapperFormModal">
                <v-card flat>
                <v-card-text>
                    <v-form>
                        <v-row no-gutters>
                            <v-col cols="12" sm="12" md="6">
                                <label class="f-label"> {{$t("Дата_приема")}} </label>
                            </v-col>
                            <v-col  cols="12" sm="12" md="6">
                                <div class="onlyReadData">
                                    {{ $moment(selectedEvent.start).format('DD.MM.YYYY') }}
                                </div>
                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col cols="12" sm="12" md="6">
                                <label class="f-label"> {{$t("Время_приема")}} </label>
                            </v-col>
                            <v-col  cols="12" sm="12" md="6">
                                <div class="onlyReadData">
                                    {{ $moment(selectedEvent.start).format('HH:mm') }} - {{ $moment(selectedEvent.end).format('HH:mm') }}
                                </div>
                            </v-col>
                        </v-row>
                        <v-row 
                            v-if="selectedEvent.FullNameRecipient"
                            no-gutters
                        >
                            <v-col cols="12" sm="12" md="6">
                                <label class="f-label"> {{$t("ФИО_ребенка")}} </label>
                            </v-col>
                            <v-col  cols="12" sm="12" md="6">
                                <div class="onlyReadData">
                                    {{ selectedEvent.FullNameRecipient }}
                                </div>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                </v-card>
            </v-card-text>
            <v-card-actions class="event-modal-actions">
                <v-spacer></v-spacer>

                <v-btn 
                    color="cyan" 
                    text
                    depressed
                    @click="$eventBus.$emit('open-document', { id: selectedEvent.id, type: 'None.Reception' })"
                >
                    {{$t("Подробнее")}}
                </v-btn>
                
                <v-btn
                    color="blue-grey" 
                    text
                    depressed 
                    @click="selectedOpen = false"
                >
                    {{$t("Закрыть")}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-menu>

  </v-sheet>
</template>

<script>
import i18n from '@/i18n';
import { mapMutations, mapGetters, mapActions } from 'vuex';
import { httpAPI } from "@/api/httpAPI";

export default {
    data: () => ({
        focus: '',
        weekDaysLocalize: [i18n.t("Вс"), i18n.t("Пн"), i18n.t("Вт"), i18n.t("Ср"), i18n.t("Чт"), i18n.t("Пт"), i18n.t("Сб")],
        //для открытия события
        selectedEvent: {},
        selectedElement: null,
        selectedOpen: false,
        customDates: [],
        isPreloaderVisible: false
    }),
    computed: {
        ...mapGetters('qalaQyzmet/receptionSchedule/calendar', 
        { 
            getCalendarPeriod: 'getCurrentPeriod',
            isPending: 'getIsPending', 
            events: 'getEvents' 
        }),
        getPeriod () {
            switch (this.getCalendarPeriod) {
              case 'day':
                return [this.$moment().day()];
              default:
                return [1, 2, 3, 4, 5, 6, 0];
            }
        },
        avaibleStatuses() {
            return this.$store.getters['qalaQyzmet/receptionSchedule/GetAvaibleStatuses'];
        },
    },
    methods: {
        ...mapMutations('qalaQyzmet/receptionSchedule/calendar', 
        { 
            setCalendarPeriod: 'SET_CURRENT_PERIOD', 
            setStartDate: 'SET_START_DATE', 
            setEndDate: 'SET_END_DATE' 
        }),
        ...mapActions('qalaQyzmet/receptionSchedule/calendar', 
        { 
            updateEvents: 'updateEvents' 
        }),
        ...mapActions(['setOverlayVisible']),
        myDayFormat(day) {
            return this.weekDaysLocalize[day.weekday];
        },
        showEvent ({ nativeEvent, event }) {
            const open = () => {
                this.selectedEvent = event
                this.selectedElement = nativeEvent.target
                requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
            }

            if (this.selectedOpen) {
                this.selectedOpen = false
                requestAnimationFrame(() => requestAnimationFrame(() => open()));
            }
            else {
                open();
            }

            nativeEvent.stopPropagation()
        },
        //#region НАВИГАЦИЯ - СВЕРХУ СЛЕВА
        prev () {
            this.$refs.calendar.prev();
        },
        next () {
            this.$refs.calendar.next();
        },
        //#endregion
        onPeriodChange(period) {
            this.setCalendarPeriod(period);
        },
        async onCalendarChange() {
            this.setStartDate(this.$refs?.calendar?.lastStart?.date);
            this.setEndDate(this.$refs?.calendar?.lastEnd?.date);

            this.updateEvents();
        },
        getDayClass(date) {
          if (this.customDates.includes(date)) {
            return 'holiday-highlight-day'
          }
          return ''
        },
        async eventDelete(event) {
             this.$notify.confirm(
                this.$t('Вы_действительно_хотите_удалить_запись'),
                async () =>
                {
                    this.setOverlayVisible({ visible: true });
                    let response = await httpAPI({
                        url: `api/actions/delete?type=None.Reception&id=${event.id}`,
                        method: 'DELETE',
                        headers: { 'Content-Type': 'application/json', 'isCommon': true }
                    });

                    if (response) {
                        this.updateEvents();
                    }

                    this.setOverlayVisible({ visible: false });
                }
            );
        }
    },
    async mounted () {
        //this.calendarObj = this.$refs?.calendar;
        // await this.loadEvents();
    },
    watch: {
        getCalendarPeriod: {
            handler () {
                this.focus = '';
            },
            deep: true,
        }
    }
}
</script>

<style scoped>
.my-event {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 2px;
  background-color: #1867c0;
  color: #ffffff;
  border: 1px solid #1867c0;
  font-size: 12px;
  padding: 3px;
  cursor: pointer;
  margin-bottom: 1px;
  left: 4px;
  margin-right: 8px;
  position: relative;
}

.my-event.with-time {
  position: absolute;
  right: 4px;
  margin-right: 0px;
}

.event-modal-actions{
  padding: 0 16px 16px 16px!important;
}
</style>